import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
export default {
    data() {
        return {

        }
    },
    computed:
        mapGetters([
            'getAccount',
            'getIsLoadingAccount',
        ]),
    //Mixin lifecycle hooks are called on any component that includes them
    methods: {
        ...mapActions([
            'fetchAccount',
        ]),
        enableInterceptor() {
            //When the token expires it is caught here
            axios.interceptors.response.use(response => {
                return response;
            }, error => {
                if (error.response.status === 401) {
                    //Check to see if this is thrown when logging in (incorrect user pass throws 403 now so not needed)
                    if (this.$router.currentRoute.meta.requiresAuth == true) {
                        //Redirect to login screen
                        this.$router.push({ path: '/Login' });
                        this.logoutFromApp();
                        this.snackPop("Session Timeout, Please log In")
                        this.updateIsLoggedIn(false);
                    }
                }
                return Promise.reject(error);
            });
        },
        handleErrorResponse(error, customErrom) {
            let details;
            console.log("handle error called");
            if (error.response.status === 400) { //maybe error.message || error.msg
                console.log({ error });
                if (error.response.data != null && error.response.data.message != null){
                    if(error.response.data.description != null){
                        try{
                            let descriptionsErrs = "";
                            let descriptionObj = JSON.parse(error.response.data.description);
                            descriptionObj.errors.forEach(element => {
                                descriptionsErrs = descriptionsErrs + ", " + element.detail;
                            });
                            details =  error.response.data.message + " " + descriptionsErrs;
                        }catch(e){
                            details = error.response.data.message;
                        }
                    }
                    else
                        details = error.response.data.message;
                    //Dispatch to app.vue to emit message
                    window.dispatchEvent(new CustomEvent('errorSnack', { detail: details}));
                }
                else
                    window.dispatchEvent(new CustomEvent('errorSnack', { detail: customErrom }));
            }
            else if (error.response.status !== 401)
                window.dispatchEvent(new CustomEvent('errorSnack', { detail: customErrom }));
        }
    }
}